// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2mDAY","buttons":"RemoveExpirationActionButtons_buttons__2zwJV"};